import React from 'react';
import './DashboardSkeleton.scss';

const DashboardSkeleton: React.FC = () => {
  return (
    <div className="dashboard-skeleton">
      <div className="dashboard-skeleton__header">
        <div className="dashboard-skeleton__title" />
        <div className="dashboard-skeleton__actions">
          <span className="dashboard-skeleton__pill" />
          <span className="dashboard-skeleton__pill dashboard-skeleton__pill--short" />
        </div>
      </div>

      <div className="dashboard-skeleton__grid">
        <div className="dashboard-skeleton__block dashboard-skeleton__block--hero">
          <div className="dashboard-skeleton__block-header">
            <span className="dashboard-skeleton__line dashboard-skeleton__line--xl" />
            <span className="dashboard-skeleton__line dashboard-skeleton__line--sm" />
          </div>
          <div className="dashboard-skeleton__bars">
            <span className="dashboard-skeleton__bar" />
            <span className="dashboard-skeleton__bar" />
            <span className="dashboard-skeleton__bar" />
            <span className="dashboard-skeleton__bar" />
          </div>
          <div className="dashboard-skeleton__row">
            <span className="dashboard-skeleton__line dashboard-skeleton__line--md" />
            <span className="dashboard-skeleton__pill dashboard-skeleton__pill--compact" />
          </div>
        </div>

        <div className="dashboard-skeleton__block dashboard-skeleton__block--wide">
          <div className="dashboard-skeleton__block-header">
            <span className="dashboard-skeleton__line dashboard-skeleton__line--lg" />
            <span className="dashboard-skeleton__line dashboard-skeleton__line--xs" />
          </div>
          <div className="dashboard-skeleton__list">
            <div className="dashboard-skeleton__row">
              <span className="dashboard-skeleton__line dashboard-skeleton__line--xl" />
              <span className="dashboard-skeleton__pill dashboard-skeleton__pill--compact" />
            </div>
            <div className="dashboard-skeleton__row">
              <span className="dashboard-skeleton__line dashboard-skeleton__line--lg" />
              <span className="dashboard-skeleton__pill dashboard-skeleton__pill--compact" />
            </div>
            <div className="dashboard-skeleton__row">
              <span className="dashboard-skeleton__line dashboard-skeleton__line--md" />
              <span className="dashboard-skeleton__pill dashboard-skeleton__pill--compact" />
            </div>
          </div>
        </div>

        <div className="dashboard-skeleton__block dashboard-skeleton__block--wide">
          <div className="dashboard-skeleton__block-header">
            <span className="dashboard-skeleton__line dashboard-skeleton__line--lg" />
            <span className="dashboard-skeleton__line dashboard-skeleton__line--xs" />
          </div>
          <span className="dashboard-skeleton__stat" />
          <div className="dashboard-skeleton__mini-grid">
            <span className="dashboard-skeleton__chip" />
            <span className="dashboard-skeleton__chip" />
            <span className="dashboard-skeleton__chip" />
            <span className="dashboard-skeleton__chip" />
          </div>
        </div>

        <div className="dashboard-skeleton__block dashboard-skeleton__block--tall">
          <div className="dashboard-skeleton__block-header">
            <span className="dashboard-skeleton__line dashboard-skeleton__line--lg" />
            <span className="dashboard-skeleton__line dashboard-skeleton__line--xs" />
          </div>
          <div className="dashboard-skeleton__list">
            <div className="dashboard-skeleton__row">
              <span className="dashboard-skeleton__line dashboard-skeleton__line--lg" />
              <span className="dashboard-skeleton__pill dashboard-skeleton__pill--compact" />
            </div>
            <div className="dashboard-skeleton__row">
              <span className="dashboard-skeleton__line dashboard-skeleton__line--md" />
              <span className="dashboard-skeleton__pill dashboard-skeleton__pill--compact" />
            </div>
            <div className="dashboard-skeleton__row">
              <span className="dashboard-skeleton__line dashboard-skeleton__line--xl" />
              <span className="dashboard-skeleton__pill dashboard-skeleton__pill--compact" />
            </div>
            <div className="dashboard-skeleton__row">
              <span className="dashboard-skeleton__line dashboard-skeleton__line--sm" />
              <span className="dashboard-skeleton__pill dashboard-skeleton__pill--compact" />
            </div>
          </div>
        </div>

        <div className="dashboard-skeleton__block dashboard-skeleton__block--compact">
          <div className="dashboard-skeleton__block-header">
            <span className="dashboard-skeleton__line dashboard-skeleton__line--md" />
            <span className="dashboard-skeleton__line dashboard-skeleton__line--xs" />
          </div>
          <div className="dashboard-skeleton__mini-grid">
            <span className="dashboard-skeleton__chip" />
            <span className="dashboard-skeleton__chip" />
          </div>
        </div>

        <div className="dashboard-skeleton__block dashboard-skeleton__block--compact">
          <div className="dashboard-skeleton__block-header">
            <span className="dashboard-skeleton__line dashboard-skeleton__line--md" />
            <span className="dashboard-skeleton__line dashboard-skeleton__line--xs" />
          </div>
          <div className="dashboard-skeleton__list">
            <span className="dashboard-skeleton__line dashboard-skeleton__line--lg" />
            <span className="dashboard-skeleton__line dashboard-skeleton__line--md" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardSkeleton;

